import { MouseEvent } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../constants';
import { Icon, Icons } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import styles from './SidebarNavLink.module.scss';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';

export type SidebarNavLinkProps = {
  label: string;
  icon: Icons;
  linkTo: RoutePaths;
  closeMobileMenu(): void;
  count?: number | null;
};
export const SidebarNavLink = ({ label, icon, linkTo, closeMobileMenu, count }: SidebarNavLinkProps) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    closeMobileMenu();
    navigate(linkTo);
    dispatch(appActions.setShowPatientCaseList(true));
  };
  return (
    <NavLink
      className={({ isActive }) => `${styles.sidebarNavLink} ${isActive ? styles.sidebarNavLinkActive : ''}`}
      onClick={onClick}
      to={linkTo}>
      <Icon name={icon} />
      <Text type="body2">{label}</Text>
      {!!count && <div className={styles.count}>{count}</div>}
    </NavLink>
  );
};
